(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hero-banners').forEach(function (root) {
      var track = root.querySelector('[data-hero-track]');
      var prev = root.querySelector('[data-hero-prev]');
      var next = root.querySelector('[data-hero-next]');
      if (!track) return;

      function step(direction) {
        var slide = track.querySelector('.hero-banner-slide');
        if (!slide) return;
        track.scrollBy({ left: slide.offsetWidth * direction, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
